<template>
  <div class="nft-detail">
    <div class="nft-detail-background" :style="backgroundImage"></div>
    <div class="nft-description">
      <nft-description :nft="nft"></nft-description>
    </div>
    <div class="nft-media">
      <nft-media :nft="nft"></nft-media>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import useNftDetails from "@/composables/useNftDetails";
import NftDescription from "@/components/NftDetails/NftDescription";
import NftMedia from "@/components/NftDetails/NftMedia";
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import imageTransformer from "@/plugins/imageTransformer";

export default {
  components: {
    NftDescription,
    NftMedia,
  },
  setup() {
    onMounted(async () => {
      await store.dispatch("nftDetails/fetchNft", route.params.id);
    });
    const store = useStore();
    const { nft } = useNftDetails(store);
    const route = useRoute();
    const backgroundImage = computed(() => {
      return nft.value.coverImage.path !== ""
        ? `background: linear-gradient(rgba(0, 0, 0, 0.6),rgba(0, 0, 0, 0.6)) , url("${imageTransformer.transform(
            nft.value.coverImage.filename,
            "nft.background"
          )}") no-repeat center center/cover`
        : "";
    });
    return {
      nft,
      backgroundImage,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/nftDetails.scss"></style>
